<template lang="pug">
    .component.reveal
        .reveal(v-f-nd="",:id="id", data-reveal, :data-options="options")
            button.close-button(data-close='', aria-label='Close modal', type='button')
                span(aria-hidden='true') &times;

            slot
</template>
<script type="text/babel">
    export default{
        name: "FoundationReveal",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        props: ['id','options']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Reveal.vue?62a4e062